import Konva from 'konva';
import * as state from '../state.js';
import { attachInteractive, pointerPos } from './_helpers.js';

let active = null;
let startX = 0;
let startY = 0;

export const ellipse = {
  id: 'ellipse',
  defaultProps: { fill: false },
  onPointerDown(engine) {
    const pos = pointerPos(engine);
    if (!engine.pointerInsideImage(pos)) return;
    startX = pos.x;
    startY = pos.y;
    const defaults = state.get('toolDefaults').ellipse ?? this.defaultProps;
    active = new Konva.Ellipse({
      x: startX,
      y: startY,
      radiusX: 0,
      radiusY: 0,
      stroke: state.get('selectedColor'),
      strokeWidth: state.get('strokeWidth'),
      fill: defaults.fill ? state.get('selectedColor') : 'transparent',
    });
    engine.contentLayer.add(active);
  },
  onPointerMove(engine) {
    if (!active) return;
    const pos = pointerPos(engine);
    const rx = Math.abs(pos.x - startX) / 2;
    const ry = Math.abs(pos.y - startY) / 2;
    active.setAttrs({
      x: (startX + pos.x) / 2,
      y: (startY + pos.y) / 2,
      radiusX: rx,
      radiusY: ry,
    });
    engine.contentLayer.batchDraw();
  },
  onPointerUp(engine) {
    if (!active) return;
    if (active.radiusX() < 2 || active.radiusY() < 2) {
      active.destroy();
    } else {
      active.remove();
      attachInteractive(engine, active);
    }
    engine.contentLayer.batchDraw();
    active = null;
  },
  apply(node, prop, value) {
    if (prop === 'color') {
      node.stroke(value);
      const fill = node.fill();
      if (fill && fill !== 'transparent') node.fill(value);
    } else if (prop === 'strokeWidth') {
      node.strokeWidth(value);
    } else if (prop === 'fill') {
      node.fill(value ? state.get('selectedColor') : 'transparent');
    }
  },
};
